import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/register/registerUI/index.tsx");
